'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBetslipId = getBetslipId;
function getBetslipId() {
    var betslipId = null;
    var betslipInfoString = window.localStorage.getItem('persist:betslip');

    if (betslipInfoString) {
        var betslipInfo = JSON.parse(betslipInfoString);
        var bookmakerInfo = JSON.parse(betslipInfo.bookmakersInfo);

        betslipId = bookmakerInfo.betslipID;
    }

    return betslipId;
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/getBetslipId.js
// module id = 1049
// module chunks = 0